import { render, staticRenderFns } from "./sfc-logo-mobile.vue?vue&type=template&id=23de3105&scoped=true&lang=pug&"
import script from "./sfc-logo-mobile.vue?vue&type=script&lang=js&"
export * from "./sfc-logo-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de3105",
  null
  
)

export default component.exports